<template>
  <div class="part-item projectTeam">
    <div class="team-wrap">
      <div class="title">
        <p class="title-text">团队主要成员</p>
        <div
          class="title-btns"
          v-show="isShow"
        >
          <a
            href="javascript:;"
            class="add teamAdd"
            data="1"
            @click="openUserWindow(1)"
          >添加成员</a>
        </div>
      </div>
      <div class="list">
        <table v-if="mainData.length">
          <tbody>
            <tr class="l_header">
              <th>姓名</th>
              <th>出生年月</th>
              <th>所在单位</th>
              <th>职称</th>
              <th>职务</th>
              <th>手机号</th>
              <th>承担任务</th>
              <th
                v-if="isShow"
                class="action"
                style="width:80px"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="(item, index) in mainData"
              :key="index"
            >
              <td class="person"><i
                  v-if="item.is_master"
                  class="person_symbol"
                >负责人</i>{{item.userprofile_id?item.userprofile.name : item.name}}</td>
              <td>{{item.birth?item.birth:'-'}}</td>
              <td>{{item.org_name?item.org_name:'-'}}</td>
              <td>{{item.rank?item.rank:'-'}}</td>
              <td>{{item.duty?item.duty:'-'}}</td>
              <td>{{formatPhone(item.userprofile_id?(item.userprofile.mobile?item.userprofile.mobile:'') : item.phone)}}</td>
              <td>{{item.task?item.task : '-'}}</td>
              <td
                class="action"
                v-if="isShow"
              >
                <a
                  class="edit"
                  style="cursor: pointer"
                  @click="showTeamTask(item)"
                >编辑</a>
                <a
                  v-if="!item.is_master"
                  class="delete"
                  style="cursor: pointer"
                  @click="delmember(item.id)"
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- <ul id="pagination" class="cN-pagination"><span class="page_total">共<b>0</b>条</span></ul> -->
    </div>
    <div class="team-wrap">
      <div class="title">
        <p class="title-text">团队其他成员</p>
        <div
          class="title-btns"
          v-show="isShow"
        >
          <a
            href="javascript:;"
            class="add teamAdd"
            data="2"
            @click="openUserWindow(0)"
          >添加成员</a>
        </div>
      </div>
      <div class="list">
        <table v-if="otherData.length">
          <tbody>
            <tr class="l_header">
              <th>姓名</th>
              <th>出生年月</th>
              <th>所在单位</th>
              <th>职称</th>
              <th>职务</th>
              <th>手机号</th>
              <th>承担任务</th>
              <th
                v-if="isShow"
                class="action"
                style="width:80px"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="(item, index) in otherData"
              :key="index"
            >
              <td>{{item.userprofile_id?item.userprofile.name : item.name}}</td>
              <td>{{item.birth?item.birth:'-'}}</td>
              <td>{{item.org_name?item.org_name:'-'}}</td>
              <td>{{item.rank?item.rank:'-'}}</td>
              <td>{{item.duty?item.duty:'-'}}</td>
              <td>{{formatPhone(item.userprofile_id?(item.userprofile.mobile?item.userprofile.mobile:'') : item.phone)}}</td>
              <td>{{item.task?item.task : '-'}}</td>
              <td
                class="action"
                v-if="isShow"
              >
                <a
                  class="edit"
                  style="cursor: pointer"
                  @click="showTeamTask(item)"
                >编辑</a>
                <a
                  class="delete"
                  style="cursor: pointer"
                  @click="delmember(item.id)"
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- <ul id="pagination1" class="cN-pagination"><span class="page_total">共<b>0</b>条</span></ul> -->
      <p
        class="part-tip"
        style="margin-top:20px"
      >团队总人数：
        <span class="teamPeoTotal">{{mainData.length+otherData.length}}</span>人
      <div class="clearfix"></div>
      <p class="tips">注：必要的技术支持人员可作为团队主要成员；“承担任务”中除填写任务分工内容外，请说明属于在线教学服务人员还是技术支持人员。</p>
      <div class="clearfix"></div>
      <div
        class="title"
        style="border-bottom:none"
      >
        <p class="title-text">团队主要成员教学情况（限500字以内）</p>
        <div
          class="title-btns action-btns"
          v-show="isShow"
        >
          <a
            v-show="isShow"
            href="javascript:;"
            @click="openTeach"
          ><i class="icon iconfont">&#xe660;</i>编辑</a>
          <a
            href="javascript:;"
            v-show="isShow"
            @click="clearItem('teach')"
          ><i class="icon iconfont">&#xe614;</i>清空</a>

        </div>
      </div>
      <div class="clearfix"></div>
      <p class="tips">（近5年来承担该实验教学任务情况，以及负责人开展教学研究、学术研究、获得教学奖励的情况）</p>
      <div class="clearfix"></div>
      <div
        class="part-content"
        v-if="!formInfo.main_member_tech"
      >暂无内容，请进行维护</div>
      <div
        class="part-content"
        v-if="formInfo.main_member_tech"
        v-html="formInfo.main_member_tech"
      ></div>
    </div>

    <div
      id="c-panel"
      style="z-index:50"
      :style="showWindow.member ? 'display: block' : ''"
    >
      <div id="c-panel-bg"></div>
      <div class="c-content">
        <form
          id="search"
          onsubmit="return false;"
        >
          <input
            type="text"
            class="s-text"
            v-model="userQueryInfo.name"
            placeholder="姓名"
          >
          <input
            type="text"
            class="s-text"
            v-model="userQueryInfo.username"
            placeholder="用户名"
          >
          <input
            type="submit"
            class="s-btn1"
            @click="pageCallback(1)"
            value="查询"
          >
          <span
            class="close-cpanel"
            @click="showWindow.member = false"
          ></span>
          <span
            class="addOtherUser"
            @click="showWindow.other_member=true"
          >新增教学服务团队成员</span>
        </form>
        <div id="uList">
          <table v-if="userData.length">
            <tbody>
              <tr class="l_header">
                <th>用户名</th>
                <th>姓名</th>
                <th>性别</th>
                <th>所属学院</th>
                <th
                  class="action"
                  style="width:150px"
                >操作</th>
              </tr>
              <tr
                class="item"
                v-for="(item, index) in userData"
                :key="index"
              >
                <td>{{ item.username}}</td>
                <td>{{ item.name}}</td>
                <td>{{ item.gender == 1 ? '男' : '女' }}</td>
                <td>{{ item.academy ? item.academy.title : '-' }}</td>
                <td class="action">
                  <a
                    class="a-button"
                    v-if="isExist(item.id)"
                    @click="addMember(item.id,1)"
                  >选择</a>
                  <a
                    class=""
                    v-else
                  >已加入</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="noitems"
            v-else
          >没有数据</div>
        </div>
        <pagination
          :cur='pageInfo.page'
          :all='pageInfo.all'
          :totalData="pageInfo.totalData"
          :callback="pageCallback"
        ></pagination>
      </div>
    </div>

    <div
      class="form_overlay"
      style="z-index: 1000;"
      id="otherUser_overlay"
      :style="formatShowWindow(showWindow.other_member)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">新增教学服务团队成员</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.other_member = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="otherUserForm">
            <div class="item">
              <span class="label">姓名</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.name"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label">出生年月</span>
              <input
                style="width:302px;height:32px"
                type="date"
                class="form-control"
                v-model="otherInfo.birth"
                autocomplete="off"
              >
            </div>
            <div class="item">
              <span class="label">所在单位</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.org_name"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label">职务</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.duty"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label">职称</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.rank"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label">手机号码</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.phone"
                autocomplete="off"
                maxlength="11"
              >
            </div>
            <div class="item">
              <span class="label">电子邮箱</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.email"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label">承担任务</span>
              <input
                type="text"
                class="form-control"
                v-model="otherInfo.task"
                autocomplete="off"
                maxlength="25"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="hideOtherMember"
            class="button close"
            id="otherUser_close"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="otherUser_submit"
            @click="addMember(0, 2)"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      class="form_overlay"
      id="CMS_overlay"
      :style="formatShowWindow(showWindow.teamtask)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">编辑成员承担任务与备注</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.teamtask = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="CMSForm">
            <div class="item">
              <span class="label"><i class="require">*</i>出生年月</span>
              <div>
                <input
                  v-model="teamFrom.birth"
                  style="width:302px;height:32px"
                  type="date"
                  class="form-control"
                >
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>所在单位</span>
              <div>
                <input
                  v-model="teamFrom.org_name"
                  type="text"
                  class="form-control"
                  maxlength="25"
                >
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>职务</span>
              <div>
                <input
                  v-model="teamFrom.duty"
                  type="text"
                  class="form-control"
                  maxlength="25"
                >
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>职称</span>
              <div>
                <input
                  v-model="teamFrom.rank"
                  type="text"
                  class="form-control"
                  maxlength="25"
                >
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>承担任务</span>
              <div>
                <input
                  v-model="teamFrom.task"
                  type="text"
                  class="form-control"
                  maxlength="25"
                >
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.teamtask = false"
            class="button close"
            id="CMS_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="editMember"
            class="button"
            id="CMS_submit"
          >提交</a>
        </div>
      </div>
    </div>
    <div
      class="form_overlay"
      id="mainTeamTeach_overlay"
      :style="formatShowWindow(showWindow.teach)"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">团队主要成员教学情况（限500字以内）</div>
        <div class="form_content">
          <form id="mainTeamTeachForm"><textarea
              class="auto"
              v-model="formTeach.main_member_tech"
              placeholder="（近5年来承担该实验教学任务情况，以及负责人开展教学研究、学术研究、获得教学奖励的情况）"
              maxlength="500"
            ></textarea>
            <div class="clearfix"></div>
            <p
              class="imgMsg"
              id="mainTeamTeach-words"
            >还可以输入<em>{{formatNum(500,formTeach.main_member_tech)}}</em>字</p>
          </form>
        </div>
        <div class="form_control "><a
            href="javascript:void(0)"
            class="button close"
            @click="showWindow.teach = false"
          >取消</a><a
            href="javascript:void(0)"
            class="button"
            id="form_mainTeamTeach_submit"
            @click="saveTeach"
          >提交</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../../components/Pager'

export default {
  name: 'ExperimentMaintainTeam',
  props: ['isShow', 'expId'],
  components: {
    Pagination
  },
  data() {
    return {
      showWindow: {
        member: false,
        other_member: false,
        teamtask: false,
        teach: false
      },
      mainData: [],
      otherData: [],
      userData: [],
      userCount: 0,
      is_main: 0,
      userQueryInfo: {
        page: 1,
        size: 10,
        name: '',
        username: '',
        role: 11,
        school_id: ''
      },
      otherInfo: {
        is_main: 0,
        name: '',
        birth: '',
        org_name: '',
        duty: '',
        rank: '',
        phone: '',
        email: '',
        task: ''
      },
      teamAllData: [],
      master_id: 0,
      formInfo: {
        main_member_tech: ''
      },
      formTeach: {
        main_member_tech: ''
      },
      // 团队成员任务对象
      teamFrom: {
        id: 0,
        birth: '',
        org_name: '',
        duty: '',
        rank: '',
        task: ''
      }
    }
  },
  computed: {
    pageInfo() {
      return {
        page: this.userQueryInfo.page,
        all: Math.ceil(this.userCount / this.userQueryInfo.size),
        totalData: this.userCount
      }
    },
    showPhone() {
      if (parseInt(this.$store.state.userInfo.role) <= 3 || this.$store.state.userInfo.profile_id === this.master_id) {
        return true
      }
      return false
    }
  },
  methods: {
    formatNum(num, val) {
      var value = val ? val.length : 0
      return Number(num - value)
    },
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    formatPhone(phone) {
      if (!phone) {
        return '-'
      }
      let res = ''
      for (let i = 0; i < phone.length; i++) {
        if (i >= 3 && i <= 6 && !this.showPhone) {
          res += '*'
        } else {
          res += phone[i]
        }
      }
      return res
    },
    openUserWindow(v) {
      this.is_main = v
      this.userQueryInfo.page = 1
      this.userQueryInfo.name = ''
      this.userQueryInfo.username = ''
      this.showWindow.member = true
      this.getUseInfo()
    },
    pageCallback(data) {
      this.userQueryInfo.page = data
      this.getUseInfo()
    },
    hideOtherMember() {
      this.otherInfo = {
        is_main: 0,
        name: '',
        birth: '',
        org_name: '',
        duty: '',
        rank: '',
        phone: '',
        email: '',
        task: ''
      }
      this.showWindow.other_member = false
    },
    showTeamTask(item) {
      this.teamFrom = {
        id: item.id,
        birth: item.birth,
        org_name: item.org_name,
        duty: item.duty,
        rank: item.rank,
        task: item.task
      }
      this.showWindow.teamtask = true
    },
    openTeach() {
      this.showWindow.teach = true
      this.formTeach.main_member_tech = this.formInfo.main_member_tech
    },
    async saveTeach() {
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, this.formTeach).then((data) => {
        if (data.id) {
          this.getInfo(data.id)
          this.formInfo.main_member_tech = this.formTeach.main_member_tech
          this.showWindow.teach = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo.main_member_tech = data.main_member_tech
        this.master_id = data.master_id
        this.userQueryInfo.school_id = data.school.id
      }).catch((error) => {
        console.log(error)
      })
    },
    formatLevel(value) {
      return value ? this.$store.state.dict_school_level[value] : '--'
    },
    formatExpLevel(value) {
      return value ? this.$store.state.dict_exp_level[value] : '--'
    },
    // 获取所有成员
    async getUseInfo() {
      if (!this.userQueryInfo.school_id) {
        this.$layer.msg('实验学校信息错误！')
        return false
      }
      await this.$http.get('/userprofile/', {
        params: this.userQueryInfo
      }).then((data) => {
        this.userData = data.results
        this.userCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取主要成员
    async getUseMember() {
      await this.$http.get('/allowany/experimentmember/', {
        params: {
          page: 1,
          size: 100,
          experiment_id: this.$route.query.id
        }
      }).then((data) => {
        this.mainData = []
        this.otherData = []
        this.teamAllData = data.results
        data.results.forEach(element => {
          if (element.is_main) {
            this.mainData.push(element)
          } else {
            this.otherData.push(element)
          }
        })
        // this.mainData = data.results
        // this.userCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    isExist(id) {
      var isExist = true
      this.teamAllData.forEach(element => {
        if (element.userprofile) {
          if (element.userprofile.id === id) {
            isExist = false
          }
        }
      })
      return isExist
    },
    async addMember(id, type) {
      if (this.mainData.length === 5 && this.is_main) {
        this.$layer.msg('团队主要成员最多可添加5人！')
        return
      }
      if (type === 2) {
        // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/ // 校验手机
        // const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ // 校验邮箱
        if (!this.otherInfo.name) {
          this.$layer.msg('请填写姓名！')
          return false
        }
        // else if (!this.otherInfo.birth) {
        //   this.$layer.msg('请选择出生年月！')
        //   return false
        // } else if (!this.otherInfo.org_name) {
        //   this.$layer.msg('请填写所在单位！')
        //   return false
        // } else if (!this.otherInfo.duty) {
        //   this.$layer.msg('请填写职务！')
        //   return false
        // } else if (!this.otherInfo.rank) {
        //   this.$layer.msg('请填写职称！')
        //   return false
        // } else if (!this.otherInfo.phone) {
        //   this.$layer.msg('请填写手机号！')
        //   return false
        // } else if (!regMobile.test(this.otherInfo.phone) && this.otherInfo.phone) {
        //   this.$layer.msg('手机号格式有误！')
        //   return false
        // } else if (!this.otherInfo.email) {
        //   this.$layer.msg('请填写邮箱！')
        //   return false
        // } else if (!regEmail.test(this.otherInfo.email) && this.otherInfo.email) {
        //   this.$layer.msg('邮箱格式有误！')
        //   return false
        // } else if (!this.otherInfo.task) {
        //   this.$layer.msg('请填写承担职务！')
        //   return false
        // }
      }
      let formInfo = {}
      if (type === 1) {
        formInfo = {
          experiment_id: this.$route.query.id,
          userprofile_id: id,
          is_main: this.is_main
        }
      } else if (type === 2) {
        formInfo.is_main = this.is_main
        formInfo.experiment_id = this.$route.query.id
        formInfo.name = this.otherInfo.name
        if (this.otherInfo.birth) {
          formInfo.birth = this.otherInfo.birth
        }
        formInfo.org_name = this.otherInfo.org_name
        formInfo.duty = this.otherInfo.duty
        formInfo.rank = this.otherInfo.rank
        formInfo.phone = this.otherInfo.phone
        formInfo.email = this.otherInfo.email
        formInfo.task = this.otherInfo.task
      }
      await this.$http.post('/experimentmember/', formInfo).then((data) => {
        if (data.id) {
          this.$layer.msg('添加成功！')
          this.showWindow.member = false
          this.hideOtherMember()
          this.getUseMember()
        } else {
          this.$layer.msg('添加失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    async delmember(id) {
      const url = '/experimentmember/' + id + '/'
      await this.$http.put(url, {
        isdel: 1
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('删除成功！')
          this.getUseMember()
        } else {
          this.$layer.msg('删除失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('删除失败！')
      })
    },
    async editMember() {
      if (!this.teamFrom.birth) {
        this.$layer.msg('请选择出生年月')
        return
      }
      if (!this.teamFrom.org_name) {
        this.$layer.msg('请填写所在单位')
        return
      }
      if (!this.teamFrom.duty) {
        this.$layer.msg('请填写职务')
        return
      }
      if (!this.teamFrom.rank) {
        this.$layer.msg('请填写职称')
        return
      }
      if (!this.teamFrom.task) {
        this.$layer.msg('请填写承担任务')
        return
      }
      const url = '/experimentmember/' + this.teamFrom.id + '/'
      await this.$http.put(url, this.teamFrom).then((data) => {
        if (data.id) {
          this.$layer.msg('修改成功！')
          this.showWindow.teamtask = false
          this.getUseMember()
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('删除失败！')
      })
    },
    clearItem(categgory) {
      switch (categgory) {
        case 'teach':
          this.formTeach = {
            main_member_tech: ''
          }
          this.saveTeach()
          break
      }
    }
  },
  async mounted() {
    await this.getUseMember()
    await this.getInfo()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  padding: 0;
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
  margin: 0 10px;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.form_content textarea.auto {
  width: 100%;
  min-height: 120px;
  padding: 15px;
  box-sizing: border-box;
}
#mainTeamTeach-words {
  padding-left: 0;
  text-align: right;
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.center_content .title .action-btns > a {
  color: #999;
  margin-left: 15px;
}
.part-content {
  border: 1px solid #f0f0f0;
  padding: 20px;
  color: #666666;
  min-height: 110px;
  overflow: hidden;
  word-break: break-all;
}
</style>
